
import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/game/day/init', method: 'GET', params }, { interceptResultCode: false });
};

// 题目列表
export const onGetList = (params) => {
  return axios({ url: '/game/day/topic/list', method: 'GET', params }, { interceptResultCode: false });
};

// 答题
export const onAnswer = (data) => {
  return axios({
    url: `/game/day/anwser`, method: 'POST', data
  }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/tideng/answer/api.js